const AiContentMarketingPricing = () => {
  return (
    <>
      <div className="ai-wt-price-area ptb-120 overflow-hidden">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-5">
              <div className="pr-20">
                <h2 className="aiwt-title text-black ff-risk-pri fs-48 mb-20">
                  Discount Up to 30% For-
                  <span className="ai-wt-brand-text fw-400">New Member</span>
                </h2>
                <p className="mb-0">
                  Streamline your video creation process by embedding your
                  videos into your authoring tool, LMS, LXP & more. Usually our
                  colleagues they but that we haven't seen before.
                </p>
              </div>
            </div>
            <div className="col-xl-7">
              <div className="row">
                <div className="col-md-6">
                  <div className="ai-wt-price-item bg-white pl-40 pr-40 pb-40 risk-shadow rounded-3 mt-20">
                    <div className="pt-40 pb-20 border-bottom">
                      <h4 className="text-black fs-36 ff-risk-pri">
                        $30<span className="fs-16 text-black">/Month</span>{" "}
                      </h4>
                      <p className="fs-14 fw-600">Get 7 Days Free Trial</p>
                    </div>
                    <ul className="ai-wt-price-list list-unstyled d-flex flex-column gap-3 mt-30 mb-30">
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">ChatGPT</span>{" "}
                          3.5Open AI Model
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">37 AI</span>{" "}
                          Templatesl
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">5000</span> Words
                          per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">10</span> Images
                          per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">2 Speech</span> to
                          Text per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">2 MB</span> Audio
                          file size limit
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">Stable</span>{" "}
                          Diffusion Images
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">AI Art</span>{" "}
                          Wizard
                        </p>
                      </li>
                    </ul>
                    <a
                      href=""
                      className="btn ai-wt-gd-bg-2 dark-bg-hover rounded-5 text-white fs-16 border-0"
                    >
                      Get Started
                    </a>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ai-wt-price-item popular bg-white pl-40 pr-40 pb-40 position-relative risk-shadow rounded-3 mt-20">
                    <div className="wt-popular-tag position-absolute">
                      <img
                        className="img-fluid"
                        src="assets/img/ai-wt-home/price_tag.png"
                        alt=""
                      />
                      <p className="text-white fw-700">Popular</p>
                    </div>
                    <div className="pt-40 pb-20 border-bottom">
                      <h4 className="text-black fs-36 ff-risk-pri">
                        $90<span className="fs-16 text-black">/Month</span>{" "}
                      </h4>
                      <p className="fs-14 fw-600">Get 7 Days Free Trial</p>
                    </div>
                    <ul className="ai-wt-price-list list-unstyled d-flex flex-column gap-3 mt-30 mb-30">
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">ChatGPT</span>{" "}
                          3.5Open AI Model
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">37 AI</span>{" "}
                          Templatesl
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">5000</span> Words
                          per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">10</span> Images
                          per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">2 Speech</span> to
                          Text per month
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">2 MB</span> Audio
                          file size limit
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">Stable</span>{" "}
                          Diffusion Images
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-3">
                        <span className="ai-wt-brand-text">
                          <i className="fa-regular fa-circle-check"></i>
                        </span>
                        <p className="mb-0">
                          <span className="text-black fw-600">AI Art</span>{" "}
                          Wizard
                        </p>
                      </li>
                    </ul>
                    <a
                      href=""
                      className="btn ai-wt-gd-bg-2 dark-bg-hover rounded-5 text-white fs-16 border-0"
                    >
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentMarketingPricing;
